export default {"src":"/portal/_next/static/media/intuit.92fcfa3b.svg","height":40,"width":152,"blurWidth":0,"blurHeight":0};